export default defineNuxtPlugin(() => {
  useFetchGeolocate()
})
